var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cloudSpace" },
    [
      _c("cloudSpatialInfo", {
        ref: "cloudSpatialInfo",
        attrs: { user: _vm.user },
      }),
      _c("file-edit", {
        attrs: {
          fileType: _vm.fileType,
          fileView: _vm.fileView,
          fromList: _vm.fromList,
        },
        on: {
          "update:fileType": function ($event) {
            _vm.fileType = $event
          },
          "update:file-type": function ($event) {
            _vm.fileType = $event
          },
          "update:fileView": function ($event) {
            _vm.fileView = $event
          },
          "update:file-view": function ($event) {
            _vm.fileView = $event
          },
          filesChange: _vm.filesChange,
          fileDownload: _vm.fileDownload,
        },
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.getnoContent,
              expression: "!getnoContent",
            },
          ],
          staticClass: "fromList",
          on: { scroll: _vm.infiniteScroll },
        },
        [
          _c(_vm.getComponents, {
            tag: "component",
            attrs: { fromList: _vm.fromList },
            on: {
              "update:fromList": function ($event) {
                _vm.fromList = $event
              },
              "update:from-list": function ($event) {
                _vm.fromList = $event
              },
              fileChange: _vm.fileChange,
              handleDel: _vm.handleDel,
              handleReload: _vm.handleReload,
              fileDownload: _vm.fileDownload,
              openViewInfo: _vm.openViewInfo,
              importModel: _vm.importModel,
              pushUserMd5: _vm.pushUserMd5,
              cancelDownload: _vm.cancelDownload,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "loading",
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/imgs/cloudSpace/loading.gif"),
              alt: "",
            },
          }),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.getnoContent,
              expression: "getnoContent",
            },
          ],
          staticClass: "noContent",
        },
        [
          _c("div", [_c("img", { attrs: { src: _vm.getImg, alt: "" } })]),
          _vm._v(" " + _vm._s(_vm.$t("no_content")) + " "),
        ]
      ),
      _c("cloudSpatialInfoDialog", {
        attrs: { item: _vm.infoItem, visible: _vm.visible },
        on: {
          importModel: _vm.importModel,
          fileDownload: _vm.fileDownload,
          fileChange: _vm.fileChange,
          "update:visible": function ($event) {
            _vm.visible = $event
          },
          pushUserMd5: _vm.pushUserMd5,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }